import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { RecordUserDailyVisitsDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const submitUserVisit = async (
  body: RecordUserDailyVisitsDto,
): Promise<void> => {
  const response = await axiosClient.post("/analytics/user-visit", body);
  return response.data;
};

function useSubmitUserVisit(
  mutationOptions?: Partial<
    UseMutationOptions<void, HttpError, RecordUserDailyVisitsDto>
  >,
) {
  return useMutation({
    mutationFn: submitUserVisit,
    ...mutationOptions,
  });
}

export { useSubmitUserVisit };
